import { render, staticRenderFns } from "./CustomerEditQuotationTreatment.vue?vue&type=template&id=1e0249ba"
import script from "./CustomerEditQuotationTreatment.vue?vue&type=script&lang=js"
export * from "./CustomerEditQuotationTreatment.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditQuotationTreatment.vue?vue&type=style&index=0&id=1e0249ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports